import once from 'lodash/once';
import { experimentId, landingId, alternativeId, hook } from '../../vendor/splitmetrics-track';
import Url from '../../lib/Url';
import { EVENT_NAME as EVENT_ANY_ACTION } from '../track-event/any-action';
import { EVENT_NAME as EVENT_INSTALL } from '../track-event/install';
import { EVENT_NAME as EVENT_APP_VIEW } from '../track-event/app-view';



const FB_PIXEL_PAGE_VIEW = 'PageView';
const FB_PIXEL_ANY_ACTION = 'ViewContent';
const FB_PIXEL_INSTALL = 'CompleteRegistration';
const FB_PIXEL_APP_VIEW = 'CompleteRegistration';
const FB_PIXEL_URL = 'https://www.facebook.com/tr/';



const fbPixel = (props, exitDelay, callback) => {
  let timer = null;
  const handler = !callback ? (() => {}) : once(() => {
    clearTimeout(timer);
    callback();
  });

  if (callback && exitDelay) {
    timer = setTimeout(handler, exitDelay);
  }

  const img = document.createElement('img');

  if (callback) {
    img.onerror = () => handler();
    img.onload = () => handler();
  }

  img.width = img.height = 1;
  img.style.display = 'none';
  img.src = `${FB_PIXEL_URL}${Url.serializeQuery(props, true)}`;

  document.body.appendChild(img);

  return img;
};



export default ({ external_id, project }) => {
  const pixelOpts = {
    id: external_id,
    content_name: project,
    content_type: 'product',
    content_ids: experimentId ? [ experimentId, alternativeId ] : [ landingId ]
  };

  fbPixel({ ...pixelOpts, ev: FB_PIXEL_PAGE_VIEW });

  const offEventAnyActionHook = hook(EVENT_ANY_ACTION, {}, () => {
    offEventAnyActionHook();
    fbPixel({ ...pixelOpts, ev: FB_PIXEL_ANY_ACTION });
  });

  const offEventInstallHook = hook(EVENT_INSTALL, {}, (props, done) => {
    offEventInstallHook();
    fbPixel({ ...pixelOpts, ev: FB_PIXEL_INSTALL }, 3000, done);
  });

  const offEventAppViewHook = hook(EVENT_APP_VIEW, {}, (props, done) => {
    offEventAppViewHook();
    fbPixel({ ...pixelOpts, ev: FB_PIXEL_APP_VIEW }, 3000, done);
  });
};



// WEBPACK FOOTER //
// ./src/lib/tracking-integrations/facebook-pixel.js